import * as Yup from "yup";
import { editTicketStatusService } from "../../services/ticketsServices.js";
import Alert from "../../utils/Alert.js";

export const initialValues = {
    status: "",
    send_sms: false,
    send_email: false,
};

export const onSubmit = async (values, actions, editingTicket, setTickets, navigate) => {
    try {
        const response = await editTicketStatusService(editingTicket.code, values);
        if (response.status === 200) {
            setTickets(prevTickets => prevTickets.map(t => {
                if(t.code === editingTicket.code) {
                    return response.data;
                }
                return t;
            }))
            Alert("انجام عملیات", "وضعیت تیکت با موفقیت ویرایش شد", "success");
            return navigate(-1);
        }
    } catch (error) {
        
    }
};

export const validationSchema = Yup.object({
    status: Yup.string().required("لطفاً یک وضعیت را انتخاب کنید")
});
